<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_loner') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_typeOfExamples') }}:
            span(slot="value") {{ $i18n.t(parameters.itemsType.label) }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
            span(slot="value") {{ $i18n.t(parameters.amountOfExamples) }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gamePlayBox_amount') + ' ' + $i18n.t(amountLabel) }}:
            span(slot="value") {{ parameters.itemsAmount }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_blackWhiteImages') }}:
            span(slot="value") {{ parameters.blackWhiteImages ? $i18n.t('trainer.trainer_gameFormSettingValue_on') : $i18n.t('trainer.trainer_gameFormSettingValue_off') }}
        br
        game-preview-setting(v-if="parameters.complication")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_complication') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSettingValue_on') }}
</template>

<script>
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        components: {
            GamePreviewSettings,
            GamePreviewSetting,
        },
        computed: {
            amountLabel() {
                return +this.parameters.itemsType.value === 2
                    ? 'trainer.trainer_gamePlayBox_couples'
                    : 'trainer.trainer_gamePlayBox_triads';
            },
        },
    };
</script>

<style scoped lang="scss">
    .image-preview-container {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 70px 0 20px 0;
        @media screen and (max-width: 575px) {
            margin: 30px 0 0 0;
        }
    }
    .image-preview {
        width: 200px;
        height: 200px;
        border-radius: 10px;
        background: $x-color-white;
    }
    .game-preview__image-label {
        width: 100%;
    }
</style>
